/**
 * @module core/version
 */

/**
 * The version of Widgetry. A test keeps it equal to the version in `package.json`.
 *
 * @type {string}
 */
export const VERSION = '1.0.0';
